<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-01-20 15:30:07
 * @FilePath: /wemeet-admin-new/src/views/exhibitionManage/components/holdMeetUserManage.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    title="协同管理"
  >
    <vab-query-form>
      <vab-query-form-left-panel :span="12" />
      <vab-query-form-right-panel :span="12">
        <el-form inline>
          <el-form-item>
            <el-input v-model="phone" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchHostInfo(row)">添加</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <div class="containerForm">
      <el-table :data="list">
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="手机号" prop="phone" />
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" @click="transferTeamworkFunc(row)">转让管理员</el-button>
            <el-button type="danger" @click="delHostInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-form :model="item" v-for="(item, index) in identityList" :key="index">
        <el-form-item :label="item.identityName"></el-form-item>
        <el-form-item label="是否开启报名">
          <el-switch v-model="item.isOpenSignUp" active-text="开启" inactive-text="关闭" />
        </el-form-item>

        <el-form-item label="报名方式	">
          <el-select v-model="item.signUpStyle" placeholder="报名方式">
            <el-option v-for="sitem in options" :key="sitem.value" :label="sitem.label" :value="sitem.value" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="save(item)">保存</el-button>
        </el-form-item>

      </el-form> -->
    </div>
    <!-- <div class="demo-drawer__footer">

    </div> -->
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { getTeamworkList, addTeamwork, delTeamwork, transferTeamwork } from '@/api/exhibitionManage'
  import { getUserByPhone } from '@/api/user'
  export default defineComponent({
    name: 'UserDetail',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
      meetingType: {
        type: String,
        default: 'HOLD_MEETING',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '50%',
        form: {},
        list: [],
        phone: '',
        options: [
          {
            value: 'FORM',
            label: '表单',
          },
          {
            value: 'NO_SIGN_UP',
            label: '无报名',
          },
        ],
      })
      // 打开
      const handleOpen = async (row) => {
        state.row = row
        state.row.meetingCode = row.meetingCode || row.code
        state.dialogFormVisible = true
        queryData()
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const queryData = async () => {
        const { data } = await getTeamworkList({
          meetingCode: state.row.meetingCode,
          meetingType: props.meetingType,
        })
        console.log(data)
        state.list = data
      }

      const save = async (item) => {
        try {
          const { data } = updateRegisterConfig(item)
          proxy.$baseMessage(`更新成功`, 'success', 'vab-hey-message-success')
          // handleClose()
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      const searchHostInfo = async () => {
        if (state.phone) {
          try {
            let phoneParams = { phone: state.phone }
            const { data } = await getUserByPhone(phoneParams)
            console.log(data)
            await addTeamwork({
              meetingCode: state.row.meetingCode,
              meetingType: props.meetingType,
              teamUid: data.weMeetUid,
            })
            queryData()
          } catch (e) {}
        } else {
          proxy.$baseMessage(`手机号不能为空`, 'error', 'vab-hey-message-error')
        }
      }

      const delHostInfo = async (item) => {
        try {
          proxy.$baseConfirm('确定删除该协同管理员吗？', '提示', async () => {
            await delTeamwork({
              meetingCode: state.row.meetingCode,
              meetingType: props.meetingType,
              teamUid: item.uid,
            })
            proxy.$baseMessage(`删除成功`, 'success', 'vab-hey-message-success')
            queryData()
          })
        } catch (e) {}
      }

      const transferTeamworkFunc = (item) => {
        try {
          proxy.$baseConfirm('确定转让管理员吗？', '提示', async () => {
            await transferTeamwork({
              meetingCode: state.row.meetingCode,
              meetingType: props.meetingType,
              phone: item.phone,
              phoneCountryCode: item.phoneCountryCode,
            })
            proxy.$baseMessage(`转让成功`, 'success', 'vab-hey-message-success')
            queryData()
          })
        } catch (e) {}
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        save,
        searchHostInfo,
        delHostInfo,
        transferTeamworkFunc,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
